/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExportStatisticsQuery } from '../models/export-statistics-query';
import { IActionResult } from '../models/i-action-result';
import { ListStatisticsQuery } from '../models/list-statistics-query';
import { ListStatisticsResult } from '../models/list-statistics-result';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation statisticsList
   */
  static readonly StatisticsListPath = '/api/Statistics/List';

  /**
   * Statisztikák listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  statisticsList$Plain$Response(params?: {
    body?: ListStatisticsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListStatisticsResult>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticsService.StatisticsListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListStatisticsResult>;
      })
    );
  }

  /**
   * Statisztikák listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  statisticsList$Plain(params?: {
    body?: ListStatisticsQuery
  },
  context?: HttpContext

): Observable<ListStatisticsResult> {

    return this.statisticsList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListStatisticsResult>) => r.body as ListStatisticsResult)
    );
  }

  /**
   * Statisztikák listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  statisticsList$Response(params?: {
    body?: ListStatisticsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListStatisticsResult>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticsService.StatisticsListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListStatisticsResult>;
      })
    );
  }

  /**
   * Statisztikák listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  statisticsList(params?: {
    body?: ListStatisticsQuery
  },
  context?: HttpContext

): Observable<ListStatisticsResult> {

    return this.statisticsList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListStatisticsResult>) => r.body as ListStatisticsResult)
    );
  }

  /**
   * Path part for operation statisticsExport
   */
  static readonly StatisticsExportPath = '/api/Statistics/Export';

  /**
   * Statisztikák exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  statisticsExport$Plain$Response(params?: {
    body?: ExportStatisticsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<IActionResult>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticsService.StatisticsExportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IActionResult>;
      })
    );
  }

  /**
   * Statisztikák exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  statisticsExport$Plain(params?: {
    body?: ExportStatisticsQuery
  },
  context?: HttpContext

): Observable<IActionResult> {

    return this.statisticsExport$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<IActionResult>) => r.body as IActionResult)
    );
  }

  /**
   * Statisztikák exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `statisticsExport()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  statisticsExport$Response(params?: {
    body?: ExportStatisticsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<IActionResult>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticsService.StatisticsExportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<IActionResult>;
      })
    );
  }

  /**
   * Statisztikák exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `statisticsExport$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  statisticsExport(params?: {
    body?: ExportStatisticsQuery
  },
  context?: HttpContext

): Observable<IActionResult> {

    return this.statisticsExport$Response(params,context).pipe(
      map((r: StrictHttpResponse<IActionResult>) => r.body as IActionResult)
    );
  }

}
